// Mock data pour les PV du Tennis Club Cheyres-Châbles

export const clubMembers = [
  'Lucile',
  'Tania', 
  'Xavier',
  'Oscar',
  'Nicolas',
  'Maxime'
];

export const mockPVs = [
  {
    id: '1',
    date: '2024-12-15',
    time: '19:00',
    presents: ['Lucile', 'Xavier', 'Oscar', 'Nicolas'],
    excuses: ['Tania', 'Maxime'],
    approbationDernierPV: 'Approuvé à l\'unanimité sans modification',
    suiviDecisions: 'Rénovation du court n°2 terminée. Budget événement été validé.',
    pointsOrdreJour: [
      {
        titre: 'Préparation tournoi d\'été 2025',
        traite: true,
        remarques: 'Dates définitives : 15-16 juillet 2025'
      },
      {
        titre: 'Renouvellement adhésions',
        traite: true,
        remarques: ''
      },
      {
        titre: 'Maintenance des courts',
        traite: false,
        remarques: 'Devis en attente pour réparation court 2'
      },
      {
        titre: 'Organisation barbecue de fin de saison',
        traite: true,
        remarques: 'Date fixée au 20 septembre'
      }
    ],
    diversPropositions: 'Proposition d\'organiser un stage jeunes pendant les vacances scolaires',
    prochainEtapes: [
      {
        tache: 'Réserver matériel pour tournoi',
        responsable: 'Xavier',
        delai: '2025-01-15',
        statut: 'En cours'
      },
      {
        tache: 'Envoyer courriers adhésions',
        responsable: 'Lucile',
        delai: '2025-01-10',
        statut: 'Terminé'
      }
    ],
    prochainComite: '2025-01-20',
    createdAt: '2024-12-15T19:00:00Z'
  },
  {
    id: '2', 
    date: '2024-11-18',
    time: '18:30',
    presents: ['Lucile', 'Tania', 'Xavier', 'Nicolas', 'Maxime'],
    excuses: ['Oscar'],
    approbationDernierPV: 'Approuvé avec correction de la date du prochain comité',
    suiviDecisions: 'Installation des nouveaux filets reportée au printemps',
    pointsOrdreJour: [
      {
        titre: 'Bilan financier saison 2024',
        traite: true,
        remarques: 'Excédent de 2500€ à reporter sur 2025'
      },
      {
        titre: 'Fermeture hivernale des courts',
        traite: true,
        remarques: ''
      },
      {
        titre: 'Planning maintenance hiver',
        traite: false,
        remarques: 'À revoir selon météo'
      }
    ],
    diversPropositions: 'Étude pour installation éclairage court n°1',
    prochainEtapes: [
      {
        tache: 'Bâcher les courts',
        responsable: 'Nicolas',
        delai: '2024-12-01',
        statut: 'Terminé'
      }
    ],
    prochainComite: '2024-12-15',
    createdAt: '2024-11-18T18:30:00Z'
  }
];

export const createEmptyPV = () => ({
  id: '',
  date: new Date().toISOString().split('T')[0],
  time: '19:00',
  presents: [],
  excuses: [],
  approbationDernierPV: '',
  suiviDecisions: '',
  pointsOrdreJour: [],
  diversPropositions: '',
  propositionsIndividuelles: [], // New field for structured individual proposals
  prochainEtapes: [],
  prochainComite: '',
  createdAt: new Date().toISOString()
});